import { styled, Tooltip } from "@material-ui/core";
import { tooltipClasses } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toggleBuildSchedulePopup } from "../../../Redux/Actions/LoginActions";
import {
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../../utils/constant";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    padding: "10px",
    border: "0.1px solid rgb(171, 171, 171)",
    boxShadow: "3px 3px 10px 6px rgba(0, 0, 0, 0.06)",
    fontFamily: "Rajdhani-SemiBold",
  },
}));
const BuildScheduleButtons = () => {
  const dispatch = useDispatch();
  const currentSeason = useSelector(
    (state) => state.loggedInUser.currentSeason
  );
  const permissionRights = useSelector(({ loggedInUser }) =>
    loggedInUser.userProfile.permissionRights.map((item) => item.displayName)
  );
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      role: role,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
      permissionRights: loggedInUser.userProfile.permissionRights.map(
        (item) => item.displayName
      ),
    };
  });
  return (
    <>
      {(userInfo.role == userRoles.ROLE_SCHOOL_ADMIN ||
        permissionRights.includes("Add/ Remove Schedule")) && (
        <>
          {currentSeason && currentSeason.years ? (
            <button
              className="build-schedule-btn bg-light-red"
              onClick={() => toggleBuildSchedulePopup(dispatch, true)}
            >
              Build Schedule
            </button>
          ) : (
            <HtmlTooltip
              title={
                <div>
                  <p className="fs-16">
                    Please Create New Season Before Building a Schedule
                  </p>
                </div>
              }
            >
              <button
                className="build-schedule-btn bg-light-red"
                disabled
                onClick={() => toggleBuildSchedulePopup(dispatch, true)}
              >
                Build Schedule
              </button>
            </HtmlTooltip>
          )}
        </>
      )}
    </>
  );
};

export default BuildScheduleButtons;
